module.exports = __webpack_public_path__ + "media/brands/massey-ferguson-55b13425.png";